import { useEffect, useState } from 'react';

import { UserConnections } from '../types/networking';
import { apiMain } from 'services/apiService';

export function useUserConnections(userId: string, loggedUserId: string) {
  const [connections, setConnections] = useState<UserConnections | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  console.log('[useUserConnections] userId', userId);
  console.log('[useUserConnections] loggedUserId', loggedUserId);

  const refresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  useEffect(() => {
    setLoading(true);
    setError(null);

    apiMain
      .get<UserConnections>(`/networking/v1/stats/connection/${loggedUserId}/${userId}`)
      .then(res => setConnections(res.data))
      .catch(err => {
        setError(err.message || 'Erro ao buscar conexões');
        setConnections(null);
      })
      .finally(() => setLoading(false));
  }, [userId, loggedUserId, refreshTrigger]);

  return { connections, loading, error, refresh };
}
